var map = {
	"./101/bg.jpeg": 2035,
	"./102/bg.jpeg": 2036,
	"./301/bg.jpeg": 2037,
	"./302/bg.jpeg": 2038,
	"./401/bg.jpeg": 2039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2034;